import type { Domain } from '@/config/domain/type';

export const trademarksOnlineNewZealand: Domain = {
    domain: import.meta.env.VITE_TMO_NZ_DOMAIN,
    website: 'https://www.trademarksonline.nz',
    shortCode: 'tmo-nz',
    markSource: 'TMOV2-NZ',
    title: 'Apply for your New Zealand trademark',
    name: 'Trademarks Online New Zealand',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your New Zealand trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-NZ.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/faq' },
        { label: 'About', url: '/aboutus' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '/img/TMO-Banner-NZ-XL.png',
    gtmId: 'GTM-K2HBMBWF',
};
